export default {
  title: 'Solicitar eliminação de dados de {{name}}',
  description:
    'Isto cria um pedido de eliminação de dados RGPD. Um administrador deve aprová-lo antes de os dados do cliente serem eliminados permanentemente.',
  form: {
    note: {
      label: 'Nota',
      placeholder: 'Adicione contexto para este pedido (opcional)',
    },
  },
  buttons: {
    confirm: 'Solicitar eliminação',
  },
  toasts: {
    success: 'Pedido de eliminação de dados criado',
    error: 'Falha ao criar pedido de eliminação de dados',
  },
};
